import api from "@/components/customAxios/Axios";
import { FiSearch, FiShare2 } from "react-icons/fi";

import { useToast } from "@/components/toast";
import { useLoader } from "@/context/loaderContext";
import { useEffect, useState } from "react";

import Modal from "react-modal";
import Pagination from "../Pagination";

Modal.setAppElement("#root");

const customStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0)", // fully transparent; change to rgba(0,0,0,0.5) for dim without blur
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
    borderRadius: "10px",

    width: "100%", // Adjust modal width for responsiveness
    maxWidth: "700px", // Max width for larger screens
    maxHeight: "90vh", // Limit height for smaller screens
    minHeight: "60vh", // Limit height for smaller screens
  },
};

type usersType = {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
};

const ShareJobModal = ({ jobId }: { jobId: string | number }) => {
  const toast = useToast();
  const { setLoading } = useLoader();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [users, setUsers] = useState<Array<usersType>>([]);
  const [selectedEmails, setSelectedEmails] = useState<string[]>([]);

  const [searchQuery, setSearchQuery] = useState("");

  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  // Reset current page to 1 whenever search query changes
  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery]);

  const getCompanyUser = async () => {
    try {
      setLoading(true);
      const response = await api.get("/company_users", {
        params: {
          per_page: 10,
          page: currentPage,
          search_value: searchQuery,
        },
      });
      if (response.status === 200) {
        setUsers(response.data.users);
        setTotalPages(response.data.total_pages);
        setTotalItems(response.data.total_count);
      }
    } catch (error: any) {
      toast.error({
        type: "background",
        duration: 5000,
        status: "error",
        title: "Error Fetching Team Users",
        description: error.response?.data?.error || error.response?.data?.message || "Failed to fetch team users. Please try again.",
        open: true,
      });
    } finally {
      setLoading(false);
    }
  };

  // Debounce the API call on searchQuery and currentPage changes
  useEffect(() => {
    const handler = setTimeout(() => {
      if (!modalIsOpen) return
      getCompanyUser();
    }, 2000);

    return () => clearTimeout(handler);
  }, [searchQuery]);

  const handlePageClick = (page: number) => {
    setCurrentPage(page);
  };

  const handleCheckboxChange = (email: string, isChecked: boolean) => {
    setSelectedEmails((prevSelected) =>
      isChecked ? [...prevSelected, email] : prevSelected.filter((e) => e !== email)
    );
  };

  const isAllSelected = users.length > 0 && selectedEmails.length === users.length;

  const handleSelectAllChange = (isChecked: boolean) => {
    setSelectedEmails(isChecked ? users.map((user) => user.email) : []);
  };

  function openModal() {
    setIsOpen(true);
    getCompanyUser()
  }

  function closeModal() {
    setIsOpen(false);
  }

  const shareJob = async () => {
    try {
      if (!selectedEmails.length) {
        toast.error({
          type: "background",
          duration: 5000,
          status: "error",
          title: "Error Sharing Job",
          description: "Please select at least one team member to share the job with.",
          open: true,
        });
        return;
      }
      setLoading(true);
      const response = await api.post("/share_job", {
        job_id: jobId,
        shared_with_emails: selectedEmails,
      });
      if (response.status === 200) {
        toast.success({
          type: "background",
          duration: 3000,
          status: "success",
          title: "Job Shared Successfully",
          description: "The job has been shared with selected team members",
          open: true,
        });
        closeModal();
        setSelectedEmails([]);
      }
    } catch (error: any) {
      toast.error({
        type: "background",
        duration: 5000,
        status: "error",
        title: "Error Sharing Job",
        description: error.response?.data?.error || error.response?.data?.message || "Failed to share job. Please try again.",
        open: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>


      <button
        onClick={openModal}
        className="cursor-pointer p-1 text-sm rounded-md hover:scale-110 transition duration-300 ease-in-out flex items-center justify-center"
      >
        <FiShare2 size={18} />

      </button>
      <Modal

        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <h3 className="text-lg font-semibold">Share Job</h3>



        <>
          <div className="w-full overflow-auto h-[70vh]">

            <div className="">

              <div className="flex justify-between gap-x-1 items-center mb-4 font-body bg-[#F9F9FA] p-1.5 rounded-xl w-full">


                {/* <div className="flex gap-x-1 items-center w-full"> */}
                <div className="relative w-full ">
                  <span className="absolute inset-y-0 left-2 flex items-center text-gray-500">
                    <FiSearch size={"18"} />
                  </span>
                  <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Search here..."
                    className="w-full p-1.5 pl-8 border  border-gray-300 rounded-lg f"
                  />
                </div>
                {/* </div> */}
              </div>

              {/* user log table */}

              <div>
                {users.length > 0 ? (
                  <table className="w-full mt-3">
                    <thead>
                      <tr className="bg-white p-3 sticky top-0 text-gray-500">
                        <th className="p-3">
                          <input
                            type="checkbox"
                            checked={isAllSelected}
                            onChange={(e) => handleSelectAllChange(e.target.checked)}
                          />
                        </th>
                        <th className="p-3 text-left">Name</th>
                        <th className="p-3 text-left">Email</th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200 font-normal">
                      {users.map((user) => {
                        const isChecked = selectedEmails.includes(user.email);
                        if (user.id === localStorage.getItem("user")) return null;
                        return (
                          <tr key={user.email} className="border-t">
                            <td className="p-3">
                              <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={(e) =>
                                  handleCheckboxChange(user.email, e.target.checked)
                                }
                              />
                            </td>
                            <td className="p-3   ">
                              {user.first_name ? (
                                user.first_name + " " + user.last_name
                              ) : (
                                <span className="text-red-500">
                                  Account setup not done
                                </span>
                              )}
                              {/* <UserLogsModal
									userName={user.user_name}
									userEmail={user.user_email}
								/> */}
                            </td>
                            <td className="p-3">{user.email}</td>
                          </tr>
                        );
                      })}
                    </tbody>

                  </table>
                ) : (
                  <div className="flex items-center justify-center h-40 w-full text-gray-500 text-xl">
                    No User Found
                  </div>
                )}
              </div>

            </div>
          </div>
          <div className=" bottom-2 left-0 w-full px-4">
            <div className="flex flex-col md:flex-row-reverse justify-between items-center w-full gap-3">

              {/* Pagination on the left (for larger screens) */}
              {users.length > 0 && (
                <div className="md:order-1 order-2 w-full md:w-auto flex justify-center md:justify-start">
                  <Pagination
                    dataLength={users.length}
                    currentPage={currentPage}
                    handlePageClick={handlePageClick}
                    totalItems={totalItems}
                    totalPages={totalPages}
                  />
                </div>
              )}

              {/* Buttons on the right */}
              <div className="md:order-2 order-1 w-full md:w-auto flex justify-center md:justify-end space-x-3">
                <button
                  className="bg-[#BDE4C3] text-[#438437] px-6 py-2 rounded-lg font-medium hover:scale-105 transition-transform"
                  onClick={shareJob}
                >
                  Share
                </button>
                <button
                  onClick={closeModal}
                  className="px-6 py-2 text-[#438437] border border-[#438437] rounded-lg font-medium hover:scale-105 transition-transform"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>

        </>
      </Modal>
    </div>
  );
};

export default ShareJobModal;

//   <div className="bg-white">
//       <div className="flex justify-between gap-x-1 items-center mb-4 font-body bg-[#F9F9FA] p-1.5 rounded-xl w-full z-30">
//           <div className="flex gap-x-3 items-center w-full ">

//               <div className="relative group ml-2">
//                   <DropdownMenu>
//                       <DropdownMenuTrigger asChild>
//                           <button className="relative flex items-center gap-2 p-2  rounded hover:bg-gray-100 transition">
//                               {/* Hamburger Icon */}
//                               <svg
//                                   width="21"
//                                   height="12"
//                                   viewBox="0 0 21 12"
//                                   fill="none"
//                                   xmlns="http: www.w3.org/2000/svg"
//                               >
//                                   <path
//                                       d="M1 1H20"
//                                       stroke="black"
//                                       strokeWidth="1.5"
//                                       strokeLinecap="round"
//                                   />
//                                   <path
//                                       d="M5 6H16"
//                                       stroke="black"
//                                       strokeWidth="1.5"
//                                       strokeLinecap="round"
//                                   />
//                                   <path
//                                       d="M9 11H12"
//                                       stroke="black"
//                                       strokeWidth="1.5"
//                                       strokeLinecap="round"
//                                   />
//                               </svg>

//                               {/* Badge */}
//                               {selectedStatus && (
//                                   <span className="absolute top-0 right-0 -mt-1 -mr-1 bg-red-500 text-white text-xs font-bold rounded-full w-4 h-4 flex items-center justify-center">
//                                       !
//                                   </span>
//                               )}
//                           </button>
//                       </DropdownMenuTrigger>

//                       <DropdownMenuContent className="w-56 p-3">
//                           <DropdownMenuLabel>Role</DropdownMenuLabel>
//                           <DropdownMenuSeparator />
//                           {statusOptions.map((status) => (
//                               <DropdownMenuItem
//                                   key={status}
//                                   onClick={() => handleSelect(status)}
//                                   className={`${selectedStatus === status
//                                       ? "bg-gray-100 font-semibold"
//                                       : ""
//                                       } cursor-pointer`}
//                               >
//                                   {status}
//                               </DropdownMenuItem>
//                           ))}
//                           <DropdownMenuSeparator />
//                           <DropdownMenuItem
//                               className="cursor-pointer font-bold"
//                               onClick={() => handleSelect("Clear")}
//                           >
//                               Clear
//                           </DropdownMenuItem>
//                       </DropdownMenuContent>
//                   </DropdownMenu>
//                   <p className="absolute  w-[100px] text-center  ml-2 px-2 py-1 text-sm bg-black text-white rounded -z-10 group-hover:z-50 transition duration-300 ease-in-out">
//                       Filter
//                   </p>
//               </div>
//               <div
//                   className="ml-2 relative group"
//                   onClick={() => {
//                       setSortValue((prev) =>
//                           prev === "-last_login" ? "last_login" : "-last_login"
//                       );
//                   }}
//               >
//                   <svg
//                       width="18"
//                       height="16"
//                       viewBox="0 0 18 16"
//                       fill="none"
//                       xmlns="http: www.w3.org/2000/svg"
//                   >
//                       <path
//                           d="M14.3536 0.646447C14.1583 0.451184 13.8417 0.451184 13.6464 0.646447L10.4645 3.82843C10.2692 4.02369 10.2692 4.34027 10.4645 4.53553C10.6597 4.7308 10.9763 4.7308 11.1716 4.53553L14 1.70711L16.8284 4.53553C17.0237 4.7308 17.3403 4.7308 17.5355 4.53553C17.7308 4.34027 17.7308 4.02369 17.5355 3.82843L14.3536 0.646447ZM13.5 1L13.5 15H14.5L14.5 1H13.5Z"
//                           fill="black"
//                       />
//                       <path
//                           d="M3.64645 15.3536C3.84171 15.5488 4.15829 15.5488 4.35355 15.3536L7.53553 12.1716C7.7308 11.9763 7.7308 11.6597 7.53553 11.4645C7.34027 11.2692 7.02369 11.2692 6.82843 11.4645L4 14.2929L1.17157 11.4645C0.976311 11.2692 0.659728 11.2692 0.464466 11.4645C0.269204 11.6597 0.269204 11.9763 0.464466 12.1716L3.64645 15.3536ZM4.5 15L4.5 1H3.5L3.5 15H4.5Z"
//                           fill="black"
//                       />
//                   </svg>

//                   <p className="absolute  w-[50px] text-center  ml-2 px-2 py-1 text-sm bg-black text-white rounded -z-10 group-hover:z-50 transition duration-300 ease-in-out">
//                       Sort
//                   </p>
//               </div>
//           </div>

//           <div className="flex gap-x-1 items-center w-full md:w-auto">
//               <div className="relative  ">
//                   <span className="absolute inset-y-0 left-2 flex items-center text-gray-500">
//                       <FiSearch size={"18"} />
//                   </span>
//                   <input
//                       type="text"
//                       value={searchQuery}
//                       onChange={(e) => setSearchQuery(e.target.value)}
//                       placeholder="Search here..."
//                       className="w-full p-1.5 pl-8 border  border-gray-300 rounded-lg f"
//                   />
//               </div>
//           </div>
//       </div>


//   </div>

//   <div className="fixed right-3 bottom-3 mt-2">
//       <Pagination
//           dataLength={users.length}
//           currentPage={currentPage}
//           handlePageClick={handlePageClick}
//           totalItems={totalItems}
//           totalPages={totalPages}
//       />
//   </div>